export default __webpack_public_path__ + "static/homepage-pottery-00138241272b2d85b210d4e048352f57.webp";